export default __webpack_public_path__ + "static/article-family-christmas-gift-guide-308eb5c299db5e180d0eb4b06f9d5d2f.jpg";